<template>
  <card class="card">
    <template slot="header">
      <div class="d-flex">
        <div class="mr-auto p-2"><h4 class="card-title">{{ $t('reportingProfileReports.title') }}</h4></div>
      </div>
    </template>

    <div class="row">
      <form @submit.stop class="form-inline">
        <div class="col-5">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            :clearable="false"
            :start-placeholder="$t('reportingProfileReports.fromDatePlaceholder')"
            :end-placeholder="$t('reportingProfileReports.toDatePlaceholder')">
            <template slot="range-separator">
              {{ $t('reportingProfileReports.toDate') }}
            </template>
          </el-date-picker>
        </div>
        <div class="col-3">
          <el-select
            value-key="id"
            class="select-primary"
            name="role"
            v-model="operator"

          >
            <el-option
              v-for="option in sortedOperators"
              class="select-primary"
              :value="option"
              :label="selectLabel(option)"
              :key="option.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-4">
          <base-button
            :disabled="!operator"
            :loading="loading"
            type="primary"
            class="btn-fill"
            @click="ticketsReport()"
          ><i class="mdi mdi_icon mdi-16px mdi-text-box-outline"/>{{
              $t('reportingProfileReports.ticketsReportBtnLbl')
            }}
          </base-button>
        </div>
      </form>
    </div>
    <div class="row">
      <div class="col-12">
        <base-button
          :loading="loading"
          type="secondary"
          class="btn-fill"
          size="md"
          @click="generateJourneysReport()"
        ><i class="mdi mdi_icon mdi-16px mdi-download-outline pr-2"/>{{
            $t('reportingProfileReports.journeysReportBtnLbl')
          }}
        </base-button>
        <base-button
          :loading="loading"
          type="secondary"
          class="btn-fill"
          size="md"
          @click="generateTopUpsReport()"
        ><i class="mdi mdi_icon mdi-16px mdi-download-outline pr-2"/>{{
            $t('reportingProfileReports.topUpsReportBtnLbl')
          }}
        </base-button>
        <base-button
          :loading="loading"
          type="secondary"
          class="btn-fill"
          size="md"
          @click="generateMoneyClaimsReport()"
        ><i class="mdi mdi_icon mdi-16px mdi-download-outline pr-2"/>{{
            $t('reportingProfileReports.moneyClaimsReportBtnLbl')
          }}
        </base-button>
      </div>
    </div>
    <hr class="mx-5">
    <div class="row">
      <div class="col-5">
        <el-date-picker
          class="mr-3"
          v-model="singleDate"
          type="date"
          :clearable="false"
          :end-placeholder="$t('reportingProfileReports.toDatePlaceholder')">
        </el-date-picker>
      </div>
      <div class="col-7">
        <base-button
          :loading="loading"
          type="secondary"
          class="btn-fill"
          size="md"
          @click="generateBalanceReport()"
        ><i class="mdi mdi_icon mdi-16px mdi-download-outline pr-2"/>{{
            $t('reportingProfileReports.balanceReportBtnLbl')
          }}
        </base-button>
      </div>
    </div>


  </card>
</template>
<script>
import {DatePicker, Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: "reporting-profile-report",
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      updated: {},
      fromDate: new Date((new Date()).getFullYear(), (new Date()).getMonth() - 1, 1),
      toDate: new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1),

      dateRange: [
        new Date((new Date()).getFullYear(), (new Date()).getMonth() - 1, 1),
        new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1),
      ],

      operator: null,

      singleDate: new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1)
    };
  },
  computed: {
    ...mapState({
      loading: state => state.reporting_profile_report.loading,
      operatorsLoading: state => state.operator.loading,
      operators: state => state.operator.data,
    }),
    sortedOperators() {
      if (this.operators) {
        return JSON.parse(JSON.stringify(this.operators));
      }

      return [];
    },
  },
  methods: {
    ...mapActions(['MakeReportingProfileJourneysReport', 'MakeReportingProfileTopUpsReport', 'MakeReportingProfileMoneyClaimsReport', 'MakeReportingProfileBalanceReport', 'LoadOperators']),

    preparePeriodQuery() {
      const from = new Date(this.dateRange[0].getTime() - (this.dateRange[0].getTimezoneOffset() * 60000))
        .toISOString()
        .split("T")[0]
      const to = new Date(this.dateRange[1].getTime() - (this.dateRange[1].getTimezoneOffset() * 60000))
        .toISOString()
        .split("T")[0]


      return {
        profile_id: this.$route.params.id,
        from: from,
        to: to,
        fare_group_id: this.operator.fare_group_id,
        operator_id: this.operator.id
      }
    },
    prepareDateQuery() {
      const to = new Date(this.singleDate.getTime() - (this.singleDate.getTimezoneOffset() * 60000))
        .toISOString()
        .split("T")[0]


      return {
        profile_id: this.$route.params.id,
        to: to,
      }
    },
    ticketsReport() {
      const q = this.preparePeriodQuery()
      this.$router.push({
        name: 'reporting-profile-tickets-report',
        params: {id: q.profile_id},
        query: {from: q.from, to: q.to, fare_group_id: q.fare_group_id, operator_id: q.operator_id},
      }).catch(err => {
      });
    },
    generateJourneysReport() {
      this.MakeReportingProfileJourneysReport(this.preparePeriodQuery())
    },
    generateTopUpsReport() {
      this.MakeReportingProfileTopUpsReport(this.preparePeriodQuery())
    },
    generateMoneyClaimsReport() {
      this.MakeReportingProfileMoneyClaimsReport(this.preparePeriodQuery())
    },
    generateBalanceReport() {
      this.MakeReportingProfileBalanceReport(this.prepareDateQuery())
    },
    selectLabel(op) {
      return op.name + ' (' + op.fare_group_id + ')'
    },
  },
  mounted() {
    this.LoadOperators()
  }
};
</script>
<style></style>
